import { render, staticRenderFns } from "./MealBreaks.vue?vue&type=template&id=53d5b7b8&scoped=true&"
import script from "./MealBreaks.vue?vue&type=script&lang=js&"
export * from "./MealBreaks.vue?vue&type=script&lang=js&"
import style0 from "./MealBreaks.vue?vue&type=style&index=0&id=53d5b7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5b7b8",
  null
  
)

export default component.exports